module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade-title",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "homepageBaseline homepageBaselineText d-flex"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Homepage.baseline')) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('Homepage.all')) + "\n          ")])])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "4%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.data), function(lineData) {
    return _c('homepage-grid-line', {
      key: lineData.id,
      attrs: {
        "lineData": lineData
      }
    })
  }), 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-662123a5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-662123a5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/Homepage.vue
// module id = 2383
// module chunks = 2